import { Fragment } from "react";
import usePage from "../hooks/usePage";
import Menu from "../modules/public/menu/menu";
import Footer from "../modules/public/footer/footer";
import { Link } from "react-router-dom";

const ExternalPage = () => {
  const { pageSliders, pageImage, pageText } = usePage();

  return (
    <Fragment>
      <Menu />

      <main className="flex-grow-1">
        {pageSliders}
        {pageText}
        <div className="home-request-page my-5">
          <div id="externalBotton">
            <Link
              to="/newex"
              style={{
                background: "transparent",
                border: "0px",
                color: "black",
              }}
            >
              <p className="home-request-style">ثبت سفارش</p>
            </Link>
          </div>
        </div>
        ;{pageImage}
      </main>

      <Footer />
    </Fragment>
  );
};

export default ExternalPage;
